import React from 'react'
import { Message } from 'rsuite'

// Create a global toaster instance
let globalToaster = null
const placement = 'topEnd'

export const setToaster = toaster => {
  globalToaster = toaster
}

export const showSuccess = text => {
  if (globalToaster) {
    globalToaster.push(
      <Message showIcon type="success">
        {text}
      </Message>,
      { placement }
    )
  }
}

export const showError = text => {
  if (globalToaster) {
    globalToaster.push(
      <Message showIcon type="error">
        {text}
      </Message>,
      { placement }
    )
  }
}

export const showWarning = text => {
  if (globalToaster) {
    globalToaster.push(
      <Message showIcon type="warning">
        {text}
      </Message>,
      { placement }
    )
  }
}

export const showInfo = text => {
  if (globalToaster) {
    globalToaster.push(
      <Message showIcon type="info">
        {text}
      </Message>,
      { placement }
    )
  }
}
